// extracted by mini-css-extract-plugin
var _1 = "table-container--nAPAk";
export { _1 as "table-container" }
